/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import _ from "underscore";

function addFeatureToMap(feature, map, style) {
	var geometry = feature.data;
	if(feature.type == "POLYGON") {
		geometry = [geometry];
	} else if(feature.type != "MULTIPOLYGON") {
		console.log("Unsupported tile geometry: " + feature.type);
		return;
	}

	return _.map(geometry, function(poly_geom) {
		var paths = _.map(poly_geom, function(path_geom) {
			return google.maps.geometry.encoding.decodePath(path_geom);
		});

		var poly = new google.maps.Polygon(_.extend({
			paths: paths,
			map: map,
		}, style));
		return poly;
	});
}

export default {
	addFeatureToMap
};
